<template>
    <div>
        <v-card>
            <v-toolbar color="info" height="40" >
                <v-toolbar-title>
                    {{ title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon color="primary" @click.prevent="closeFileUpload()">
                    <v-icon>clear</v-icon>
                </v-btn> -->
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <input type="file" id="file" ref="file" class="btn color-primary" @change="handleFileUpload()"/>
                    </v-flex>
                    <v-flex xs12 v-show="!isItemImageUpload">
                        <v-text-field
                            :rules="[]"
                            v-model="notes"
                            label="Notes"
                            hint
                            persistent-hint
                        ></v-text-field>

                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="uploadFile">Upload</v-btn>
                <v-btn color="info" @click.native="closeFileUpload">Cancel</v-btn>
                <!-- <v-btn color="green darken-1" flat="flat" @click.native="resetUser">Reset</v-btn> -->

                <v-spacer></v-spacer>
            </v-card-actions>

        </v-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['quoteId', 'itemIdUploadImage'],
  data() {
    return {
      file: null,
      notes: null,
    }
  },
  computed: {
      title () {
          return this.isItemImageUpload? "Upload Image" : "Upload File"
      },
      isItemImageUpload () {
          return this.itemIdUploadImage
      },
  },
  methods: {
      ...mapActions('quoteWorkflow', [
          'uploadQuoteFile'
      ]),
      async uploadFile () {
          const formData = new FormData()
          formData.append('file', this.file)
          // I put all data into a json string, 
          // then send to server side
          var data = {
              id: this.quoteId,
              itemIdUploadImage: this.itemIdUploadImage,
              notes: this.notes,
          }
          formData.append('data', JSON.stringify(data))

          await this.uploadQuoteFile(formData)

          this.$emit('fileUploaded')
          this.closeFileUpload()
      },
      closeFileUpload () {
          this.file = null
          this.notes = null

          this.$emit('closeFileUpload')
      },
      handleFileUpload () {
          this.file = this.$refs.file.files[0];
      },
  }
}
</script>